<template>
      <v-card
          class="tw-w-full tw-flex tw-flex-row tw-text-center tw-rounded-lg md:tw-text-left">
        <div :class="['tw-w-full tw-flex ', isSelected?'tw-border tw-rounded-lg tw-border-blue-500 tw-shadow-lg':'']">
          <div class="tw-w-full tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-justify-center tw-items-center tw-my-5 md:tw-my-6 tw-flex-wrap">
              <div class="tw-w-full tw-flex tw-px-2 md:tw-px-4 xl:tw-px-4">
                  <div class="tw-px-2 md:tw-px-3 lg:tw-px-4">
                      <h3
                          class="c-blue-text c-title tw-text-lg tw-text-xl-2 md:tw-text-xl tw-flex tw-justify-center tw-justify-items-center">
                          <slot/>
                      </h3>
                  </div>
              </div>
              <div
                  class="tw-w-full tw-place-items-center tw-grid  tw-px-2 md:tw-px-4 tw-border-r-0 md:tw-border-r-0 tw-border-gray-400 tw-border-l-0 md:tw-border-l-2 tw-mt-5 md:tw-mt-0">
                  <div class="tw-ml-5">
                    <h4 class="c-light-blue-text tw-text-base tw-font-bold">Premium to pay:</h4>
                    <h3 class="c-gray-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ this.premiumAmount | formatNum}}</h3>
                  </div>
              </div>
          </div>
          <div v-if="showSelected" class="tw-flex tw-align-top tw-justify-end tw-p-2 tw-pb--2" >
            <v-icon class="tw-h-6 tw-m-2" :color="isSelected?'green':'primary'" large>{{ isSelected? "mdi-check-circle" : "mdi-circle-outline"}}</v-icon>
          </div>
        </div>
      </v-card>
</template>
<script>
import helpers from '@/utils/helpers';

export default {
  name: 'PremiumAmount',
  props: {
    premiumAmount: {
      type: Number,
      required: true,
    },
    showSelected: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
